<template>
  <div>
    <div class="columns">
      <div class="column ">
        
        <b-field>
          <b-input v-model="searchName" placeholder="Search Room"></b-input>
        </b-field>
      </div>
        <div class="column">
        <b-field >
           <b-select placeholder="Select Season" 
           icon="snowflake" 
           expanded  
           v-model="selectedSeason"
           @input="changeSeasonSelected"
          
            >
           <option 
           v-for="season in seasons" 
           v-bind:key="season.label" 
           :value="season">{{season.label}}
           </option>
        </b-select>
        </b-field>
        </div>
      
      <div class="column is-3">
        
        <a class="button full-width-button is-primary" @click="openModal">
            <span class="icon is-small">
              <i class="fas fa-plus"></i>
            </span>
            <span>Add</span>
          </a>
      </div>
    </div>
      <div class="has-text-centered">
      <hr v-if="!rooms">  <img :src="'/static/nodata.gif'" v-if="!rooms" alt="No data Found" style="height : 200pt"> <p class="subtitle" v-if="!rooms">Rooms not found in {{city.name}} !</p>
       <!--  <p v-if="!rooms">Please add new room from + button..</p>  -->
        <hr v-if="!rooms">
      <!--   <div v-if="!rooms.lenght">
                   
        <div class="subtitle">No Rooms Found!</div> <hr v-if="!rooms.lenght">
        </div> -->
        </div> 
    <div class="columns is-multiline ">
  
      <div class="column is-6" v-for="room in filterBy(rooms, searchName)" :key="room.name" >
       
       <div class="card" >
          <div class="card-content">
            <div class="has-text-centered">
            <b-tag type="is-primary" rounded>{{room.name }}</b-tag>
        </div>
          </div>
          <footer class="card-footer">
               <a class="card-footer-item" @click="openModal(room)">  <b-tooltip label="Edit Room" position="is-right"><b-icon type='is-primary' size="is-small" icon="edit"></b-icon> </b-tooltip></a> 
            <a class="card-footer-item" @click="deleteRoom(room)"><b-tooltip label="Delete Room" position="is-right"><b-icon type='is-info' size="is-small" icon="trash"></b-icon></b-tooltip></a>
          </footer>
        </div>
      </div>
      
    </div>
 
  </div>
</template>

<script>
import ManageRooms from './ManageRooms';
import RoomService from './service';
import UploadService from '../../../lib/UploadService';

export default {
  name: 'deliveryBoys',

  props: ['city', 'season',],

  created() {
   
      this.fetchRooms1();
      this.$bus.$on('CITY_CHANGED', season => {
      // this.city = city;
     this.fetchRooms1();
    });
  //  this.fetchRooms2();
  },

  data() {
    return {
      isLoading: true,
      seasons: null,
      searchName: null,
      files: null,
      rooms : null,
      selectedSeason : null,
    
    };
  },

  methods: {
    selectedSeasonfun(season) {
               return this.selectedSeason && this.selectedSeason.docId === season.docId;  
               //console.log(selectedSeason);
            },
    changeSeasonSelected(season) {
      this.selectedSeason = season;
      console.log(this.selectedSeason);
      this.$bus.$emit('SEASON_CHANGED', season);
      this.$toast.open({
                    message: 'Current season updated!',
                     position: 'is-top',
                    type: 'is-success'
            });
      this.fetchRooms2();
    },
    fetchRooms1() {
      RoomService.all(this.city).then(data => {
        this.seasons = data;
        this.isLoading = false;
        //console.log("Seasons :",this.seasons);
      });
        
    },
     fetchRooms2() {
      // console.log("Selected" , this.selectedSeason)
      RoomService.roomsfetch(this.selectedSeason).then(data => {
        this.rooms = data;
        this.isLoading = false;
        //console.log("Rooms :", this.rooms);
      });
        
    }, 
     
  deleteRoom(roomToBeDeleted) {
      this.$dialog.confirm({
        message: 'Sure to delete room?',
        onConfirm: () => {
            RoomService.deleteRoom(this.selectedSeason, roomToBeDeleted).then(() => {
            this.rooms = this.rooms.filter(room => room.docId !== roomToBeDeleted.docId);
            this.$toast.open({
                    message: 'Room Deleted Successfully !',
                    position: 'is-top',
                    type: 'is-danger'
            });
          });
        }
      });
    },

    openModal(room = null) {
      //console.log("Modal", room.rates.adult)
      this.$modal.open({
        parent: this,
        props: {
          propRoom : room,
          city: this.city
        },
        component: ManageRooms,
        hasModalCard: true
      });
    },

/*     uploadImage(season) {
      UploadService(
        this.files[0],
        `cities/${this.city.docId}/delivery-seasons`,
        season.docId
      )
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    } */
  }
};
</script>

<style scoped>
.season-image {
  height: 100px;
  margin-top: 1rem;
}

.room-container {
  
  overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/Rooms/Rooms.vue